import React from 'react';
import { Container, Row, Col } from 'reactstrap';


const deg = {
    fontSize : '12px',
    background: '#FFDB8A'
    // background: 'rgba(252,234,187,1)',
    // background: '-moz-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: '-webkit-gradient(left top, left bottom, color-stop(0%, rgba(252,234,187,1)), color-stop(42%, rgba(252,205,77,1)), color-stop(88%, rgba(248,182,5,1)), color-stop(91%, rgba(248,181,0,1)), color-stop(100%, rgba(251,223,147,1)))',
    // background: '-webkit-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: '-o-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: '-ms-linear-gradient(top, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // background: 'linear-gradient(to bottom, rgba(252,234,187,1) 0%, rgba(252,205,77,1) 42%, rgba(248,182,5,1) 88%, rgba(248,181,0,1) 91%, rgba(251,223,147,1) 100%)',
    // filter: 'progid:DXImageTransform.Microsoft.gradient( startColorstr=\'#fceabb\', endColorstr=\'#fbdf93\', GradientType=0 )'
}


const title = {
    textAlign: 'center',
    fontSize: '18px',
    color: 'black',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '700'
}

const txt2 = {
    textAlign: 'center',
    fontSize: '18px',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: '700'
}

const mystyle = {
    maxWidth: '100%',
    height: 'auto'
}

const contimg = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}



const ImageRecord3 = () => {
    return(
        <Container style={deg}>
            <Row>
                <Col style={title}>¡Gracias!</Col>
            </Row>
            <Row>
                <Col style={txt2}>Estamos cargando tu respuesta, por favor espera unos segundos mas</Col>
            </Row>
            <Row>
                <Col style={title}>Piensa antes de contestar</Col>
            </Row>
            <Row>
                <Col xs={12} style={{fontFamily: "'Nunito', sans-serif"}}>
                <ul> 
                    <li>Responda clara y brevemente</li> 
                    <li>Di siempre la verdad</li> 
                    <li>Si te preguntan sobre ti mismo/a, enfatiza tu información, experiencia y resultados de trabajo</li> 
                    <li>Evita dar respuestas que no respondan a lo que te preguntaron</li>
                    <li>Intenta no responder con monosílabos (Si/No)</li>
                    <li>Intenta no utilizar expresiones tajantes "siempre, nunca", ni utilices muletillas, "este", "bueno"...</li>
                    <li>No te niegues a responder preguntas</li>
                    <li>Muestra entusiasmo por el trabajo, pero no lo supliques</li>
                    <li>No hables mal de las empresas en las que has trabajado, ni de tus jefes anteriores</li>
                </ul>
                </Col>
                <Col xs={12} style={contimg}>
                    <img  style={mystyle} id="img_loading" src={`${process.env.PUBLIC_URL}/images/InterPregTec/manoVertical.png`} alt="Smiley face" />
                </Col>
            </Row>
            <Row>
                <Col style={title}>¡Ahora estás preparado para brillar en las entrevistas laborales!</Col>
            </Row>
        </Container>
    );
}

export default ImageRecord3;